// extracted by mini-css-extract-plugin
export default {"navbar-environment-label":"NavMenu_navbar-environment-label__XFSJC"};